import { render, staticRenderFns } from "./activist.vue?vue&type=template&id=3c035f4c&scoped=true"
import script from "./activist.vue?vue&type=script&lang=js"
export * from "./activist.vue?vue&type=script&lang=js"
import style0 from "./activist.vue?vue&type=style&index=0&id=3c035f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c035f4c",
  null
  
)

export default component.exports